import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Bare /auth has no UI of its own — legacy emails, older docs, and the
 * onboarding cron all link to /auth expecting the sign-in page. Redirect
 * server-side to /login so a fresh browser hit never sees a 404.
 */
export const Route = createFileRoute("/auth/")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/login", search: search as Record<string, unknown> });
  },
  component: () => null,
});
